import React from "react";
import ForgotPassword from "../components/ForgotPassword/ForgotPassword";

function ForgotPasswordPage() {
  return <ForgotPassword />;
}

export default ForgotPasswordPage;
